export default {
  "title": "Find us @rocketsofawesome",
  "content": "Follow us on Instagram for parent hacks, outfit tips, and the stuff we’re just super obsessed with right now. Plus, check out #ROAINTHEWILD to see how real kids are sporting their favorite styles IRL."
}



// WEBPACK FOOTER //
// ./src/modules/social-media/defaultProps.js